
import { Component, Vue } from 'vue-property-decorator'
import DatePicker from '@/components/date-picker.vue'
import { apiGoodsPool, apiGoodsPoolStatus, apiGoodsPoolExport, apiKpGoodsClassify } from '@/api/supplier'
import { apiKpGoodsPoolDetail } from '@/api/goods'
import ExportData from '@/components/export-data/index.vue'
import { RequestPaging } from '@/utils/util'
import { OrderType } from '@/utils/type'
import LsPagination from '@/components/ls-pagination.vue'
import LsDialog from '@/components/ls-dialog.vue'
@Component({
    components: {
        DatePicker,
        ExportData,
        LsPagination,
        LsDialog
    }
})
export default class Commodity extends Vue {
    // S Data
    $refs!: { turnDown: any; modifyPrice: any }
    activeName: any = 'all' //全部;
    data: any = []
    cascaderValue: any = []
    apiGoodsPoolExport = apiGoodsPoolExport
    tabs = [
        {
            label: '全部',
            name: 'all'
        },
        {
            label: '待付款',
            name: OrderType[0]
        },
        {
            label: '已完成',
            name: OrderType[1]
        }
    ]
    pageSize: any = {
        page: 0,
        size: 10
    }
    pager = new RequestPaging()

    form: any = {
        endTime: '',
        startTime: '',
        title: '',
        code: '',
        supplierName: '',
        state: ''
    }
    total: any = 0
    otherLists: any = {
        set_meal: [],
        pay_status: [],
        pay_way: []
    }
    turnDownMsg: any = '' //驳回原因
    turnDownGoodId: any = '' //驳回商品ID
    skus: any = {} //商品规格详情
    specificationType: any = 1 //商品规格类型
    putawayID: any = '' //上架商品ID
    goodDetail: any = {}
    propres = {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node: any, resolve: any) {
            const level = node.level
            const parentId = node.value
            let options: any
            if (level == 0) {
                apiKpGoodsClassify({ id: 0 }).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else if (level == 1) {
                const params = {
                    id: parentId
                }
                apiKpGoodsClassify(params).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else if (level == 2) {
                const params = {
                    id: parentId
                }
                apiKpGoodsClassify(params).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else {
                resolve()
            }
        }
    }
    // E Data

    // S Methods
    reset() {
        this.form = {
            endTime: '',
            startTime: '',
            title: '',
            code: '',
            supplierName: '',
            state: ''
        }
        this.cascaderValue = []
        this.getSupplierShopLists(0)
    }

    //商品列表
    getSupplierShopLists(page?: number) {
        page == 0 && (this.pageSize.page = page)
        apiGoodsPool({
            ...this.form,
            ...this.pageSize
        }).then(res => {
            this.data = res.rows
            this.total = +res.total
        })
    }
    cascaderChange(data: any) {
        this.form.thirdCategoryId = data[2]
        this.form.secondCategoryId = data[1]
        this.form.firstCategoryId = data[0]
    }
    getGoodDetail(id: any) {
        this.putawayID = id
        apiKpGoodsPoolDetail({ id: id })
            .then((res: any) => {
                this.skus = res.skus.map((item: any) => {
                    return {
                        id: item.id,
                        salePrice: item.salePrice,
                        specificationValue: item.specificationValue,
                        marketPrice: item.marketPrice,
                        settlementPrice: item.settlementPrice
                    }
                })
                this.goodDetail = res
                this.$refs.modifyPrice.open()
            })
            .catch(rej => {
                this.$message({
                    message: rej,
                    type: 'error'
                })
            })
    }
    //上架
    putaway() {
        if (this.skus.some((item: any) => item.salePrice < 0)) {
            this.$message({
                message: '销售价格必须大于等于0',
                type: 'error'
            })
            return
        }
        apiGoodsPoolStatus({ state: 2, id: this.putawayID, skuSalePriceList: this.skus }).then(res => {
            this.$message({
                message: '上架成功',
                type: 'success'
            })
            this.getSupplierShopLists(0)
            this.$refs.modifyPrice.close()
        })
    }
    //导出
    exportGoodsData() {
        apiGoodsPoolExport({}).then(res => {
            this.$message({
                message: '导出成功',
                type: 'success'
            })
            window.location.href = res.fileUrl
        })
    }
    turnDown() {
        if (this.turnDownMsg == '') {
            this.$message({
                message: '请输入驳回原因',
                type: 'error'
            })
            return
        }
        apiGoodsPoolStatus({ state: 0, id: this.turnDownGoodId, message: this.turnDownMsg }).then(res => {
            this.$message({
                message: '驳回成功',
                type: 'success'
            })
            this.getSupplierShopLists(0)
            this.$refs.turnDown.close()
        })
    }
    turnDown2(id: any) {
        apiGoodsPoolStatus({ state: 0, id: id }).then(res => {
            this.$message({
                message: '下架成功',
                type: 'success'
            })
            this.getSupplierShopLists(0)
        })
    }
    //分页
    handleSizeChange(size: any) {
        this.pageSize.size = size
        this.getSupplierShopLists(0)
    }
    handleCurrentChange(page: any) {
        this.pageSize.page = page - 1
        this.getSupplierShopLists()
    }
    // E Methods

    // S  life cycle

    created() {
        this.getSupplierShopLists(0)
    }

    // E life cycle
}
